import * as actionTypes from './actionsTypes';
import axios from '../../http-config';
import { Category } from '@material-ui/icons';
import swal from 'sweetalert';

export const fetchStateDashboardSuccess = (response) => {
    return {
        type: actionTypes.FETCH_STATE_DASHBOARD_SUCCESS,
        data: response.data.data,
        id:response
      
    }
}

export const fetchStateDashboardFail = (error) => {
    return {
        type: actionTypes.FETCH_STATE_DASHBOARD_FAIL,
        error:error
    }
}

export const fetchStateDashboardStart = () => {
    return {
        type: actionTypes.FETCH_STATE_DASHBOARD_START
    }
}

export const fetchStateDashboardChartDataSuccess = (response) => {
    return {
        type: actionTypes.FETCH_STATE_DASHBOARD_CHART_DATA_SUCCESS,
        data: response.data.data,
        totalLoadsCount: !!response.data.data.dashboard_data ?response.data.data.dashboard_data[0].table_data.maxNoOfLoadsReceived:0

    }
}

export const fetchStateDashboardChartDataFail = (error) => {
    return {
        type: actionTypes.FETCH_STATE_DASHBOARD_CHART_DATA_FAIL,
        error:error
    }
}

export const fetchStateDashboardChartDataStart = () => {
    return {
        type: actionTypes.FETCH_STATE_DASHBOARD_CHART_DATA_START
    }
}

export const fetchStateDashboard = (payload,filter) => {
    let token = payload.token;
    let interval = payload.interval
        return async dispatch => {
        dispatch(fetchStateDashboardStart());

        //to handle API call when category is STP 
        let FSTPORSTP = payload.category == 1 ? `&startutilizationRateIn=${payload.startutilizationRateIn}&endutilizationRateIn=${payload.endutilizationRateIn}` :''
        //  `&startLoadValues=${payload.startutilizationRateIn}&endLoadValues=${payload.endutilizationRateIn}`
        let tfFacility = payload.category == 0  ? '' : `&treatmentFacilityType=${payload.category}`
        try {
            const response = await axios({
                method: 'get',
                url: filter ? `state_dashboard?startDate=${payload.startDate}&endDate=${payload.endDate}${FSTPORSTP}${tfFacility}${filter} `:
                `state_dashboard?startDate=${payload.startDate}&endDate=${payload.endDate}${FSTPORSTP}${tfFacility}`,
                headers: {'Authorization': `Bearer ${payload.token}`}
            })
            if(response){
                const fetchedEmailManageResponse = response;
                dispatch(fetchStateDashboardSuccess(fetchedEmailManageResponse));
                const data = response.data.data.dashboard_data[0].table_data.body
                if(data.length == 0){
                    swal("No Records Found !", {
                        icon: "warning",
                      });
                }
            }
            return response
        }catch(error){
            dispatch(fetchStateDashboardFail(error));
        }
    }
    
}


export const fetchStateDashboardExcal = (payload)=>{
    return dispatch =>{
        dispatch(fetchStateDashboardStart());
        const url = payload.category == 1 ? `state_dashboard?startDate=${payload.startDate}&endDate=${payload.endDate}&startutilizationRateIn=${payload.startutilizationRateIn}&endutilizationRateIn=${payload.endutilizationRateIn}&treatmentFacilityType=${payload.category}&export=${payload.excalDownload}`:
        `state_dashboard?startDate=${payload.startDate}&endDate=${payload.endDate}&treatmentFacilityType=${payload.category}&export=${payload.excalDownload}`
        // &startLoadValues=${payload.startutilizationRateIn}&endLoadValues=${payload.endutilizationRateIn}
        axios.get(url, { headers: {'Authorization': `Bearer ${payload.token}`}})
        .then(response=>{
            let urlExcal=response.data.data.dashboard_data[0].table_data.data[0].file_path
            window.downloadFile = function (linkExcal) {
                window.open(linkExcal, '_blank');
            }
            window.downloadFile(urlExcal)
          
        }).catch(error=>{
            dispatch(fetchStateDashboardFail(error));
        })
    }
   
}

export const fetchChartData = (payload) => {
    let token = payload.token;
    let interval = payload.interval

    return dispatch => {
        let tfFacility = payload.category == 0  ? '' : `&treatmentFacilityType=${payload.category}`
        axios({
            method: 'get',
            url: payload.category == 1 ? 
            `state_dashboard?topTenValues=true&startDate=${payload.startDate}&endDate=${payload.endDate}&startutilizationRateIn=${payload.startutilizationRateIn}&endutilizationRateIn=${payload.endutilizationRateIn}${tfFacility}`:
            `state_dashboard?topTenValues=true&startDate=${payload.startDate}&endDate=${payload.endDate}&${tfFacility}`,
            headers: {'Authorization': `Bearer ${payload.token}`}
        })
        .then((response) => {
            dispatch(fetchStateDashboardChartDataSuccess(response));
        }).catch(error => {
            dispatch(fetchStateDashboardChartDataFail(error));
        })

    }
}
 
export const fetchStatDashboardChart = (payload) => {
    let interval = payload.interval

    return dispatch => {
        dispatch(fetchStateDashboardStart());
        const url = `/?interval=${interval}`;

        axios({
            method: 'get',
            url: '/dashboard'+url,
            headers: {'Authorization': `Bearer ${payload.token}`}
        })
        .then((response) => {
            // const fetchedEmailManageResponse = response.data;
            dispatch(fetchStateDashboardChartDataSuccess(response));
        }).catch(error => {
            dispatch(fetchStateDashboardChartDataFail(error));
        })

    }
}